import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cliterals(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>Literal in C tutorial For Beginners</title>
 <meta name="description" content="Literal in C tutorial for beginners.Those value fixed to a variable and refer to fixed values. This is known as literal,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c literal,c string literal,c literal suffix,character literal c,c struct literal initialization,c raw string literal multi-line,c language binary literal,literal constant in c" />
 <link rel="canonical" href="https://www.codeexampler.com/c-literal" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Literal in C</h1>
    <div className="first">
        <a href="/c-input">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Q-what is literals in a C programming language?</h2>
   <p className="mt-4 para"> <span className="bold">Answer-</span>Those values are fixed to a variable and refer to fixed values. That is known as literal.</p>
    <p className="mt-4 para">1, Literal is also known as constants<br/>
2, Literal depends upon its type<br/>
3, C literals have any primitive data types<br/>
</p>

<h2 className='headings'>Literal in C Programming language example</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"100vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-5">   int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= "</span>
            <span className="qwerty-9">Code Exampler</span>
            <span className="qwerty-3">"; </span>
        {"\n"}{"\n"}
            <span className="qwerty-7">   int</span>
            <span className="qwerty-3"> is a data_types</span>
                    {"\n"}{"\n"}
            <span className="qwerty-6">   a</span>
            <span className="qwerty-3"> is a variable</span>
            {"\n"}{"\n"}
            <span className="qwerty-10">   = </span>
            <span className="qwerty-3">is an operator</span>
                    {"\n"}{"\n"}
            <span className="qwerty-4">   Code Exampler</span>
            <span className="qwerty-3"> is a C string literal</span>
                    {"\n"}{"\n"}
           
        </code>
    </pre>
    </div>  

<h2 className="mt-4 mh2">There are many types of literals:<br/>
</h2>

<h3 className="mt-4 mh3">1, String Literals<br/>
2, Integer Literals<br/>
3, Float Literals<br/>
4, Double Literals<br/>
5, Character Literals<br/>
6, Boolean Literals<br/>
7, Null Literals
</h3>

<h2 className="mt-4 mh2">1, String literal in C Programming language example: <br/></h2>



<h2 className='headings'>Q-Write a program print String literal in C programming example?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"100vh"}}>
  <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     string</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3"> = "</span>
                <span className="qwerty-9">hello</span> 
                <span className="qwerty-3">"</span>  
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}  
          <span className="qwerty-5">     string</span>              
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">= </span>
                <span className="qwerty-3">" </span>
                <span className="qwerty-9">ram</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}     
            <span className="qwerty-8">     OR</span>
            {"\n"}{"\n"}      
            <span className="qwerty-5">     string</span>     
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">, </span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}  
            <span className="qwerty-10">     a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">" </span>
                <span className="qwerty-9">hello</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>         
                {"\n"}{"\n"}                          
                <span className="qwerty-10">     b</span>
                <span className="qwerty-3"> =</span>
                <span className="qwerty-3">" </span>
                <span className="qwerty-9">ram</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>    
                    {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">(</span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-3">" "</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3">);</span>
                       {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
                <span className="qwerty-4" >&#125;</span>
        </code>{"\n"}{"\n"}
    
      </pre>
    </div>  
    
    <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >                    
                    {"\n"}
                        <span className="qwerty-10">hello </span>
                        <span className="qwerty-10">ram</span>
                             {"\n"}{"\n"}
            
                </code>
                </pre>
                </div> 


<h2 className="mt-4 mh2">2, Integer Literal in C :</h2>


<h2 className='headings'>Q-Write a program print Integer literal in C programming example ?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">     int </span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-9">10</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
            <span className="qwerty-5">     int </span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-9">200</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}                
            <span className="qwerty-8">      OR</span>
            {"\n"}{"\n"}                
                <span className="qwerty-5">     string</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">, </span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}            
                
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">( </span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-11"> + </span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3"> );</span>
                       {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
                <span className="qwerty-4" >&#125;</span>
        </code>{"\n"}{"\n"}
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"50vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">210</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
        </div>


<h2 className="mt-4 mh2">3, Float Literal in C Example:</h2>



<h2 className='headings'>Write a program print float Literal in C programming example ? </h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> float </span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">, </span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}    
                <span className="qwerty-10"> a</span>  
                <span className="qwerty-3"> =</span>  
                <span className="qwerty-10"> 400.8206</span>  
                <span className="qwerty-3">;</span>  
                {"\n"}{"\n"}      
                <span className="qwerty-10"> b</span>  
                <span className="qwerty-3"> =</span>  
                <span className="qwerty-10"> 40.25</span>  
                <span className="qwerty-3">;</span>  
                {"\n"}{"\n"}                                   
                <span className="qwerty-7"> printf</span>
                <span className="qwerty-3"> ("</span>
                <span className="qwerty-10"> a float value </span>
                <span className="qwerty-4">%f </span>
                <span className="qwerty-8">\n </span>
                <span className="qwerty-3">", </span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-3">); </span>
            {"\n"}{"\n"}    
          
                <span className="qwerty-7"> printf</span>
                <span className="qwerty-3"> ("</span>
                <span className="qwerty-10"> b float value </span>
                <span className="qwerty-4">%f </span>
                <span className="qwerty-8">\n </span>
                <span className="qwerty-3">", </span>
                <span className="qwerty-10">borderRadius</span>
                <span className="qwerty-3">); </span>
                {"\n"}{"\n"}    
            </code>
          </pre>
          </div>

           <h4 className='headings'>Output :</h4>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> a float value of  400.820600 </span>
            {"\n"}{"\n"}    
                <span className="qwerty-10"> b float value of 40.250000</span>  
                {"\n"}{"\n"}     
            </code>
          </pre>
          </div>  


<h2 className="mt-4 mh2">4, Double Literal in c programming language example:</h2>


<h2 className='headings'>Write a program print Double literal in C programming example ? </h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> double </span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">, </span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}    
                <span className="qwerty-10"> a</span>  
                <span className="qwerty-3"> =</span>  
                <span className="qwerty-10"> 400.8206</span>  
                <span className="qwerty-3">;</span>  
                {"\n"}{"\n"}      
                <span className="qwerty-10"> b</span>  
                <span className="qwerty-3"> =</span>  
                <span className="qwerty-10"> 40.25684</span>  
                <span className="qwerty-3">;</span>  
                {"\n"}{"\n"}                                  
                <span className="qwerty-7"> printf</span>
                <span className="qwerty-3"> ("</span>
                <span className="qwerty-10"> a double value </span>
                <span className="qwerty-4">%if </span>
                <span className="qwerty-8">\n </span>
                <span className="qwerty-3">", </span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-3">); </span>
            {"\n"}{"\n"}    
     
                <span className="qwerty-7"> printf</span>
                <span className="qwerty-3"> ("</span>
                <span className="qwerty-10"> b double value </span>
                <span className="qwerty-4">%if </span>
                <span className="qwerty-8">\n </span>
                <span className="qwerty-3">", </span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-3">); </span>
                {"\n"}{"\n"}    
            </code>
          </pre>
          </div>

           <h4 className='headings'>Output :</h4>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> a double value of  400.821 </span>
            {"\n"}{"\n"}    
                <span className="qwerty-10"> b double value of 40.2568</span>  
                {"\n"}{"\n"}     
            </code>
          </pre>
          </div>   

<h2 className="mt-4 mh2">5, Character Literals</h2>
    



<h2 className='headings'>Q- Write a program a and b in Character literals in C programming example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> char </span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty-3">= "</span>
                <span className="qwerty-9">hello</span>
                <span className="qwerty-3">";</span>
            {"\n"}{"\n"}    
            
            <span className="qwerty-5"> char </span>
                <span className="qwerty-10"> b </span>
                <span className="qwerty-3">= "</span>
                <span className="qwerty-9">ram 5</span>
                <span className="qwerty-3">";</span>
                {"\n"}{"\n"}  
                <span className="qwerty-8">  OR</span>
            {"\n"}{"\n"} 
                <span className="qwerty-5"> char </span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}  
                <span className="qwerty-10"> a </span>
                <span className="qwerty-3">= "</span>
                <span className="qwerty-9">hello</span>
                <span className="qwerty-3">";</span>
            {"\n"}{"\n"} 
                <span className="qwerty-10"> b </span>
                <span className="qwerty-3">= "</span>
                <span className="qwerty-9">code Exampler 100</span>
                <span className="qwerty-3">";</span>
            {"\n"}{"\n"}                   
            </code>
          </pre>
          </div> 


<h2 className="mt-4 mh2">6, Boolean Literals:</h2>



<h2 className='headings'>Q- Write a program and b in Boolean literals in C programming example ?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
  <span className="qwerty-5"> Boolean</span>  
                <span className="qwerty-10"> a</span>  
                <span className="qwerty-3"> = "</span>  
                <span className="qwerty-9">true</span>  
                <span className="qwerty-3">";</span> 
                {"\n"}{"\n"}            
                <span className="qwerty-5"> Boolean</span>  
                <span className="qwerty-10"> b</span>  
                <span className="qwerty-3"> = "</span>  
                <span className="qwerty-9">false</span>  
                <span className="qwerty-3">";</span> 
                {"\n"}{"\n"}    
                <span className="qwerty-8">     OR</span>  
                {"\n"}{"\n"}
                <span className="qwerty-5">     Boolean</span>
                <span className="qwerty-10"> a</span>  
                <span className="qwerty-3">,</span>  
                <span className="qwerty-10"> b</span>  
                <span className="qwerty-3">;</span>  
                {"\n"}{"\n"}  
                <span className="qwerty-10"> a</span>  
                <span className="qwerty-3"> = "</span>  
                <span className="qwerty-9">true</span>  
                <span className="qwerty-3">";</span>
                {"\n"}{"\n"} 
                <span className="qwerty-10"> b</span>  
                <span className="qwerty-3"> = "</span>  
                <span className="qwerty-9">false</span>  
                <span className="qwerty-3">";</span> 
                {"\n"}{"\n"}
            </code>
          </pre>
          </div> 

<h2 className="mt-4 mh2">Null Literals:</h2>
<p className="mt-4 para"> Null Literal is using to indicate that this object is not available more.</p>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-input">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cliterals;